import { formatCustomerDateTime } from "../../Utils/autopilotDateTime";

const CHANNEL_LABELS = { whatsapp: "הודעת וואטסאפ", sms: "הודעת SMS" };
const WORKFLOW_ICONS = {
  phone: "https://ucarecdn.com/c99f9a41-cdce-4442-af19-50f253a1a426/noroot.png",
  sms: "https://ucarecdn.com/57dc21df-d4b8-482b-9474-b25a38c187dc/noroot.png",
  whatsapp: "https://ucarecdn.com/07924b0e-c9ae-4f34-9117-2f641148cfa2/noroot.png",
  eventDay: "https://ucarecdn.com/2cbc6fba-8565-4386-bb17-2de07c104d90/noroot.png",
  thankYou: "https://ucarecdn.com/50c649f8-64a8-480f-9136-985b0772920e/noroot.png",
};

export const workflowStepIcon = (step = {}) => {
  if (step.kind === "voice") return WORKFLOW_ICONS.phone;
  if (step.kind === "thankYou") return WORKFLOW_ICONS.thankYou;
  if (step.messagePurpose === "confirmedReminder") return WORKFLOW_ICONS.eventDay;
  return step.channel === "whatsapp" ? WORKFLOW_ICONS.whatsapp : WORKFLOW_ICONS.sms;
};

const giftAudienceText = (audience) => ({
  approved: "למי שאישר הגעה",
  approvedAndPending: "למי שאישר ולמי שעדיין לא ענה",
  all: "לכל האורחים",
})[audience || "all"];

export const workflowStepParts = (step = {}) => {
  const channel = CHANNEL_LABELS[step.channel];
  if (step.kind === "voice") return { action: "שיחת טלפון אוטומטית", detail: "חיוג למי שעדיין לא ענה" };
  if (step.kind === "thankYou") return { action: "הודעת SMS תודה", detail: "יום אחרי האירוע למי שאישר" };
  if (step.kind === "giftLink") return { action: `${channel} עם קישור מתנה`, detail: `קישור מאובטח ${giftAudienceText(step.audience)}` };
  if (step.messagePurpose === "invitation") return { action: channel, detail: "הזמנה ראשונה לאורחים" };
  if (step.messagePurpose === "unansweredReminder") return { action: `${channel} נוספת`, detail: "תזכורת למי שעדיין לא ענה" };
  if (step.messagePurpose === "confirmedReminder") return { action: `${channel} ביום האירוע`, detail: "תזכורת ומספר שולחן למי שאישר" };
  return { action: channel || "הודעה אוטומטית", detail: "שלב אוטומציה" };
};

export const workflowStepText = (step) => {
  const { action, detail } = workflowStepParts(step);
  return `${action} — ${detail}`;
};

const PackageWorkflowCards = ({
  steps = [],
  headingId,
  headingNote = "ניתן לשנות תאריכים ושעות לאחר הרכישה",
  loading = false,
  error = "",
  className = "",
  getCardClassName,
  renderCopyExtras,
  renderCardAction,
  onCardClick,
  isCardClickable,
  getCardAriaLabel,
}) => (
  // Presentation only: callers supply already-calculated Steps and scheduledAt values.
  <section className={`autopilot-commerce__modal-workflow ${className}`.trim()} aria-labelledby={headingId}>
    <h3 id={headingId}>
      <span className="autopilot-commerce__workflow-heading-copy">
        <span>לוח הזמנים לשליחת ההודעות באירוע שלכם</span>
        <span className="autopilot-commerce__workflow-heading-note">{headingNote}</span>
      </span>
    </h3>
    {loading && <p className="autopilot-commerce__preview-state">מחשב את המועדים לפי תאריך ושעת האירוע…</p>}
    {error && <p className="autopilot-commerce__preview-error" role="alert">{error}</p>}
    <ol>{steps.map((step, index) => {
      const benefit = workflowStepParts(step);
      const copyExtras = renderCopyExtras?.(step, index);
      const action = renderCardAction?.(step, index);
      const clickCard = onCardClick && (!isCardClickable || isCardClickable(step, index))
        ? () => onCardClick(step, index)
        : null;
      const cardClassName = getCardClassName?.(step, index) || "";
      return (
        <li
          key={step.id}
          className={cardClassName}
          role={clickCard ? "button" : undefined}
          tabIndex={clickCard ? 0 : undefined}
          aria-label={clickCard ? getCardAriaLabel?.(step, index) : undefined}
          onClick={clickCard || undefined}
          onKeyDown={clickCard ? (event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              clickCard();
            }
          } : undefined}
        >
          <span className="autopilot-commerce__benefit-number" aria-hidden="true">{String(index + 1).padStart(2, "0")}</span>
          <span className="autopilot-commerce__step-icon" aria-hidden="true"><img src={workflowStepIcon(step)} alt="" /></span>
          <span className="autopilot-commerce__benefit-copy">
            <strong>{benefit.action}</strong>
            <span>{benefit.detail}</span>
            {step.scheduledAt && <time dateTime={step.scheduledAt}>{formatCustomerDateTime(step.scheduledAt)}</time>}
            {copyExtras}
          </span>
          {action && <span className="autopilot-commerce__workflow-card-action">{action}</span>}
        </li>
      );
    })}</ol>
  </section>
);

export default PackageWorkflowCards;
